import { useState, useCallback, useEffect } from 'react';
import { logger } from '@nykaa/logger';
import {
  addWindowHandler,
} from './helpers';


export const useGamoogaData = () => {
  const [gamoogaNotification, setGamoogaNotification] = useState(null);
  const addHandler = useCallback(() => {
    addWindowHandler((params) => {
      try {
        setGamoogaNotification(params);
      } catch (error) {
        logger.error(error, 'error in gamooga call back');
      }
    });
  }, []);
  useEffect(() => {
      addHandler();
  }, [addHandler]);
  return gamoogaNotification;
};
